"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationStatus = exports.IntegrationType = void 0;
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["Acumen"] = "Acumen";
    IntegrationType["GitHub"] = "GitHub";
    IntegrationType["JIRA"] = "Jira";
    IntegrationType["BitbucketCloud"] = "BitbucketCloud";
    IntegrationType["BitbucketServer"] = "BitbucketServer";
    IntegrationType["Slack"] = "Slack";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["CREATED"] = "Created";
    IntegrationStatus["INACTIVE"] = "Inactive";
    IntegrationStatus["ACTIVE"] = "Active";
    IntegrationStatus["DESTROYED"] = "Destroyed";
    IntegrationStatus["INVALIDATED"] = "Invalidated";
})(IntegrationStatus = exports.IntegrationStatus || (exports.IntegrationStatus = {}));
//# sourceMappingURL=integration.js.map